<template>
  <!-- container tab views -->
  <v-container grid-list-md class="app-container" pb-0 v-if="this.$store.getters.programsFetched">
    <v-layout row>
      <h1>{{ $t('message.dealerAppHeader') }}</h1>
      <v-spacer></v-spacer>
      {{ $t('message.lastUpdateDate') }}:
      {{ formatDate(this.$store.getters.getDealerApplication.lastUpdateDate) }}
      <br />
      Application Id: {{ this.$store.getters.getDealerApplication.id }}
    </v-layout>

    <p v-html="$t('message.dealerAppInfo')"></p>
    <!-- main tab view -->
    <div
      id="tabs-application"
    >
      <v-tabs
        v-model="currentTab"
        color="grey darken-2"
        dark
        slider-color="orange"
        show-arrows
      >
        <v-tab>
          1. {{ $t('message.tabHeader.applicant') }} &nbsp;
          <img
            src="static/icons/check_circle_gray.png"
            width="26"
            v-if="this.$store.getters.isDealerInfoComplete"
          />
          <img src="static/icons/error_outline_gray.png" width="26" v-else />
        </v-tab>
        <v-tab-item>
          <v-card flat xs12>
            <applicant></applicant>
          </v-card>
        </v-tab-item>

        <v-tab>
          2. {{ $t('message.tabHeader.proofOfBusEntity') }} &nbsp;
          <img
            src="static/icons/check_circle_gray.png"
            width="26"
            v-if="this.$store.getters.isIncArticlesComplete"
          />
          <img src="static/icons/error_outline_gray.png" width="26" v-else />
        </v-tab>
        <v-tab-item>
          <v-card flat xs12>
            <inc-articles></inc-articles>
          </v-card>
        </v-tab-item>

        <v-tab>
          3. {{ $t('message.tabHeader.owners') }} &nbsp;
          <img
            src="static/icons/check_circle_gray.png"
            width="26"
            v-if="this.$store.getters.isOwnerComplete"
          />
          <img src="static/icons/error_outline_gray.png" width="26" v-else />
        </v-tab>
        <v-tab-item>
          <v-card flat xs12>
            <owners></owners>
          </v-card>
        </v-tab-item>

        <v-tab>
          4. {{ $t('message.tabHeader.storeLocations') }} &nbsp;
          <img
            src="static/icons/check_circle_gray.png"
            width="26"
            v-if="this.$store.getters.isLocationsComplete"
          />
          <img src="static/icons/error_outline_gray.png" width="26" v-else />
        </v-tab>
        <v-tab-item>
          <v-card flat xs12>
            <store-locations></store-locations>
          </v-card>
        </v-tab-item>

        <v-tab v-if="this.$store.getters.isACHRequired">
          5. {{ $t('message.tabHeader.achInfo') }} &nbsp;
          <img
            src="static/icons/check_circle_gray.png"
            width="26"
            v-if="this.$store.getters.isAchComplete"
          />
          <img src="static/icons/error_outline_gray.png" width="26" v-else />
        </v-tab>
        <v-tab-item v-if="this.$store.getters.isACHRequired">
          <v-card flat xs12>
            <ach-info></ach-info>
          </v-card>
        </v-tab-item>

        <v-tab>
          {{getTabCnt()}}. {{ $t('message.tabHeader.finalize') }} &nbsp;
          <img
            src="static/icons/check_circle_gray.png"
            width="26"
            v-if="this.$store.getters.isDealerApplicationComplete(false)"
          />
          <img src="static/icons/error_outline_gray.png" width="26" v-else />
        </v-tab>
        <v-tab-item>
          <v-card flat xs24 sm12>
            <finalize></finalize>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </div>

    <footer-bar></footer-bar>
  </v-container>
</template>

<script>
import axiosMixin from '@/mixins/axiosMethods'
import Applicant from './Application/Applicant'
import IncArticles from './Application/IncArticles'
import Owners from './Application/Owners'
import StoreLocations from './Application/StoreLocations'
import AchInfo from './Application/AchInfo'
import Finalize from './Application/Finalize'
import { EventBus } from '../main.js'

export default {
  data() {
    return {
      currentTab: 0,
      showSuccess: false,
      showError: false,
      required: ''
    }
  },
  mixins: [axiosMixin],
  computed: {
    dealerApplication() {
      return this.$store.getters.getDealerApplication
    }
  },
  methods: {
    onNextTab() {
      if (this.currentTab < this.getTabCnt() - 1) {
        this.currentTab += 1
      }
    },
    onPrevTab() {
      if (this.currentTab > 0) {
        this.currentTab -= 1
      }
    },
    getTabCnt() {
      return this.$store.getters.isACHRequired ? 6 : 5
    }
  },
  components: {
    applicant: Applicant,
    'inc-articles': IncArticles,
    owners: Owners,
    'store-locations': StoreLocations,
    'ach-info': AchInfo,
    finalize: Finalize
  },
  created() {
    EventBus.$on('onNextTab', this.onNextTab)
    EventBus.$on('onPrevTab', this.onPrevTab)
  },
  beforeDestroy() {
    EventBus.$off('onNextTab', this.onNextTab)
    EventBus.$off('onPrevTab', this.onPrevTab)
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.getters.getUnsavedData) {
      var shouldContinue = window.confirm(
        'Do you really want to leave? You have unsaved changes!'
      )
      if (shouldContinue) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Application.vue